/**
 * @typedef {Object} YatzyPoint
 * @property {string} type - Den unikke identifikator for pointkategorien
 * @property {string} prettyName - Det visuelle navn der vises i brugergrænsefladen
 * @property {number[]} values - Array af mulige pointværdier for kategorien
 * @property {number[]} [sixDiceValues] - Valgfri array af pointværdier specifikke for 6-terninge spil
 */

/**
 * Array af alle Yatzy pointkategorier og deres mulige værdier
 * @type {YatzyPoint[]}
 */
export const yatzyPoints = [
    { 
        type: 'Ones', 
        prettyName: `1'ere`,
        description: 'Summen af alle 1’ere.',
        values: [1, 2, 3, 4, 5],
        sixDiceValues: [6]
    },
    {
        type: 'Twos',
        prettyName: `2'ere`,
        description: 'Summen af alle 2’ere.',
        values: [2, 4, 6, 8, 10],
        sixDiceValues: [12]
    },
    {
        type: 'Threes',
        prettyName: `3'ere`,
        description: 'Summen af alle 3’ere.',
        values: [3, 6, 9, 12, 15],
        sixDiceValues: [18]
    },
    {
        type: 'Fours',
        prettyName: `4'ere`,
        description: 'Summen af alle 4’ere.',
        values: [4, 8, 12, 16, 20],
        sixDiceValues: [24]
    },
    {
        type: 'Fives',
        prettyName: `5'ere`,
        description: 'Summen af alle 5’ere.',
        values: [5, 10, 15, 20, 25],
        sixDiceValues: [30]
    },
    {
        type: 'Sixes',
        prettyName: `6'ere`,
        description: 'Summen af alle 6’ere.',
        values: [6, 12, 18, 24, 30],
        sixDiceValues: [36]
    },
    {
        type: 'OnePair',
        prettyName: '1 Par',
        description: 'To ens. Pointene er summen af parret.',
        values: [2, 4, 6, 8, 10, 12],
    },
    {
        type: 'TwoPairs',
        prettyName: '2 Par',
        description: 'To forskellige par. Pointene er summen af begge par.',
        values: [6, 8, 10, 12, 14, 16, 18, 20, 22],
    },
    {
        type: 'ThreePairs',  // New category for 6-dice mode
        prettyName: '3 Par',
        description: 'Tre par. Kun med 6 terninger. Summen af parrene.',
        values: [12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
    },
    {
        type: 'ThreeOfAKind',
        prettyName: '3 ens',
        description: 'Tre ens. Summen af de tre terninger.',
        values: [3, 6, 9, 12, 15, 18],
    },
    {
        type: 'FourOfAKind',
        prettyName: '4 ens',
        description: 'Fire ens. Summen af de fire terninger.',
        values: [4, 8, 12, 16, 20, 24],
    },
    {
        type: 'TwoTimesThreeOfAKind',
        prettyName: '2x3 ens',
        description: 'To sæt med tre ens. Kun med 6 terninger. Summen af alle seks.',
        values: [9, 12, 15, 18, 21, 24, 27, 30, 33]
    },
    {
        type: 'SmallStraight',
        prettyName: 'Lille Straight',
        description: '1-2-3-4-5. Fast 15 point.',
        values: [15],
    },
    {
        type: 'LargeStraight',
        prettyName: 'Stor Straight',
        description: '2-3-4-5-6. Fast 20 point.',
        values: [20],
    },
    {
        type: 'royal', // New category for 6-dice mode
        prettyName: 'Royal',
        description: '1-2-3-4-5-6. Kun med 6 terninger. Fast 30 point.',
        values: [30]
    },
    {
        type: 'FullHouse',
        prettyName: 'Hus',
        description: 'Tre ens og et par. Summen af alle terningerne.',
        values: [7, 8, 9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 28],
    },
    {
        type: 'Chance',
        prettyName: 'Chance',
        description: 'Summen af alle terningerne, når kastet ikke bruges til andet.',
        values: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
        sixDiceValues: [31, 32, 33, 34, 35, 36]
    },
    {
        type: 'Yatzy',
        prettyName: 'Yatzy',
        description: 'Fem ens. 50 point.',
        values: [50],
    }
]